var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"clear",on:{"click":_vm.clear}},[_vm._v("点击清除")])])
}
var staticRenderFns = []

export { render, staticRenderFns }